module.exports = __webpack_public_path__ + "media/images/curriculum_h1_background_image-cd308f503491af8dd0edf0798fa2a6ea.png";